import { Injectable } from '@angular/core';
import { HttpClient, HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  constructor(private http: HttpClient) { }

  get<T>(url: string) {
    return this.http.get<T>(url);
  }

  post<T>(t: T, url: string) {
    return this.http.post(url, t);
  }

  put<T>(t: T, url: string) {
    return this.http.put(url, t);
  }

  delete(id: number, url: string, body: any = undefined) {
    if (!body) 
      return this.http.delete(`${ url }/${ id }`);
    else
      return this.http.request('delete', `${ url }/${ id }`, {
        body: body
      });
  }

  deleteWithoutId(url: string, body: any = undefined) {
    return this.http.request('delete', `${ url }`, {
      body: body
    });
  }
}

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor() {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    request = request.clone({
      setHeaders: {
        Authorization: `Bearer ${localStorage.getItem('token')}`
      }
    });
    return next.handle(request);
  }
}